import {
  getChipText,
  getBtnText,
  optionDescription,
  optionFields,
  OPTION_NAME_MAP,
} from "../data/getting-started";

export const OptionCard = ({ option, optionObj = {} }) => {
  const isFilled = !!optionObj[optionFields[option]];
  const chipText = getChipText(option, isFilled);
  const buttonText = getBtnText(option, isFilled);
  return (
    <article>
      <div>
        <p className="s2">{OPTION_NAME_MAP[option]}</p>
        <p className="p5 mt-2">{optionDescription[option]}</p>
        {!!chipText && (
          <div className={`chip ${isFilled ? "info check" : "warning"} mt-4`}>
            {chipText}
          </div>
        )}
      </div>
      {buttonText && (
        <div>
          <a
            href={`/actions/refresh?modal[type]=${option}`}
            data-button-type="outline"
            role="button"
          >
            <span>{buttonText}</span>
          </a>
        </div>
      )}
    </article>
  );
};
